export function dateParser(s) {
  if (!s) return null;
  s = s.trim();

  // Default: 100 years ago from today
  let  minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 100);

  // Handle pure digits like 01071981 → 01/07/1981
  if (/^\d{8}$/.test(s)) {
    s = `${s.slice(0, 2)}/${s.slice(2, 4)}/${s.slice(4, 8)}`;
  }

  // Accept "/", "-", or "." as separators
  const parts = s.split(/[/. -]/).map((p) => p.trim());
  if (parts.length < 3) return null;

  let [first, second, third] = parts.map(Number);
  let month, day, year;

  // Detect YYYY-MM-DD (e.g. browser autofill) when first part is clearly a year
  if (first > 31) {
    [year, month, day] = [first, second, third];
  } else {
    [month, day, year] = [first, second, third];
  }

  // Normalize short year: 89 → 1989, 11 → 2011
  if (year < 100) {
    year += year > 30 ? 1900 : 2000;
  }

  // Basic validation
  if (
    month < 1 ||
    month > 12 ||
    day < 1 ||
    day > 31 ||
    year < 1900 ||
    year > new Date().getFullYear()
  ) {
    return null;
  }

  const parsedDate = new Date(year, month - 1, day);

  if (isNaN(parsedDate.getTime())) return null;

  // Range enforcement
  const today = new Date();
  if (parsedDate > today || parsedDate < minDate) {
    return null;
  }

  return parsedDate;
}